import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";

/**
 * Shared header pattern for all AI block cards.
 * Shows a display name, optional raw/subtitle name, and a type chip via content projection.
 */
@Component({
  selector: "app-card-header",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatTooltip],
  templateUrl: "./card-header.component.html",
  styleUrl: "./card-header.component.scss",
})
export class CardHeaderComponent {
  displayName = input.required<string>();

  rawName = input<string>("");
}
